import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/movies';

const hotMoviePosters: Record<number, string> = {
  101: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20dramatic%20golden%20lighting%2C%20space%20theme%2C%20dark%20warm%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=hot-movie-poster-101&orientation=portrait',
  102: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20epic%20movie%20poster%20with%20dramatic%20warm%20lighting%2C%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic%2C%20ancient%20warrior&width=600&height=900&seq=hot-movie-poster-102&orientation=portrait',
  103: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20warm%20golden%20lighting%2C%20boxing%20theme%2C%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=hot-movie-poster-103&orientation=portrait',
  104: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%20with%20dark%20moody%20lighting%2C%20film%20noir%20style%2C%20warm%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=hot-movie-poster-104&orientation=portrait',
  105: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20romance%20movie%20poster%20with%20beautiful%20sky%20background%2C%20warm%20golden%20lighting%2C%20cinematic%20style%2C%20professional%20anime%20film%20poster%20aesthetic&width=600&height=900&seq=hot-movie-poster-105&orientation=portrait',
  106: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20dark%20intense%20lighting%2C%20urban%20night%20theme%2C%20warm%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic&width=600&height=900&seq=hot-movie-poster-106&orientation=portrait',
  107: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20animated%20movie%20poster%20with%20ancient%20Tang%20dynasty%20theme%2C%20warm%20golden%20lighting%2C%20poetic%20style%2C%20cinematic%20animation%20poster%20aesthetic&width=600&height=900&seq=hot-movie-poster-107&orientation=portrait',
  108: 'https://readdy.ai/api/search-image?query=Historical%20biographical%20drama%20movie%20poster%20with%20dramatic%20warm%20lighting%2C%20dark%20background%2C%20cinematic%20style%2C%20professional%20film%20poster%20aesthetic%2C%20intense%20expression&width=600&height=900&seq=hot-movie-poster-108&orientation=portrait',
};

export default function RecommendedGrid() {
  return (
    <section className="w-full px-4 md:px-8 py-6 md:py-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-5 md:mb-6">
          <h3 className="text-lg md:text-xl font-heading text-foreground-100">
            热门推荐
          </h3>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-base"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {hotMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group block"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-200 mb-3">
                <img
                  src={hotMoviePosters[movie.id] || movie.imageUrl}
                  alt={movie.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 px-1.5 py-0.5 bg-primary-500/90 text-background-950 rounded text-xs font-medium">
                  {movie.quality}
                </div>
                <div className="absolute top-2 left-2 px-1.5 py-0.5 bg-background-950/70 backdrop-blur-sm text-primary-400 rounded text-xs font-medium flex items-center gap-0.5">
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400"></i>
                  </span>
                  {movie.rating}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-background-950/90 to-transparent">
                  <div className="flex items-center gap-1.5">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-play-circle-fill text-primary-400 text-sm"></i>
                    </span>
                    <span className="text-xs text-foreground-200">{movie.views}</span>
                  </div>
                </div>
              </div>

              <h4 className="text-sm md:text-base font-medium text-foreground-200 group-hover:text-primary-400 transition-colors line-clamp-1 mb-1">
                {movie.title}
              </h4>
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span>{movie.year}</span>
                <span className="w-0.5 h-0.5 rounded-full bg-foreground-600"></span>
                <span>{movie.duration}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}